export default {
    typography: {
        fontFamily: 'MarkPro, "Helvetica", "Arial", sans-serif',
        fontWeightRegular: 300,
        fontWeightMedium: 400,
        fontWeightBold: 700,
    },
};
